{
  "secretary": {
    "navLabel": "منشی هوشمند",
    "title": "منشی هوشمند {{brand}}",
    "recorder": {
      "record": "یک فرمان بگویید — مثلاً «برای رضایی فردا ساعت ده نوبت بده»",
      "recording": "می‌شنوم…",
      "stop": "توقف و اجرا",
      "discard": "دور انداختن",
      "processing": "منشی مشغول است…",
      "warn": {
        "nothing": "چیزی نشنیدم",
        "busy": "منشی هنوز مشغول فرمان قبلی است",
        "mic": {
          "denied": "اجازهٔ میکروفون داده نشده است",
          "unsupported": "این مرورگر ضبط صدا ندارد",
          "error": "میکروفون باز نشد"
        }
      }
    },
    "notice": {
      "listLabel": "نتیجه‌های منشی هوشمند",
      "heard": "شنیدم: «{{text}}»",
      "dismiss": "بستن",
      "more": "{{count}} نتیجهٔ دیگر",
      "open": "باز کردن",
      "bookReady": "نوبت {{name}} آماده است",
      "followUpReady": "پیگیری {{name}} آماده است",
      "slotLine": "{{day}}، ساعت {{time}}",
      "slotLineClinic": "{{day}}، ساعت {{time}} — {{clinic}}",
      "noSlot": "وقت خالی پیدا نشد",
      "choosePatient": "کدام «{{name}}»؟",
      "candidates": "{{count}} بیمار با این نام",
      "notFound": "«{{name}}» در بیماران شما نیست",
      "openRecord": "پروندهٔ {{name}}",
      "daySummary": "امروز {{total}} نوبت دارید",
      "noClinic": "شما کلینیکی برای ثبت نوبت ندارید",
      "outOfScope": "این کار از منشی ساخته نیست",
      "unavailable": "برنامهٔ امروز خوانده نشد",
      "unknown": "متوجه نشدم",
      "failed": "منشی نتوانست کار را انجام دهد",
      "noCredit": "{{coin}} کافی نیست"
    },
    "window": {
      "close": "بستن",
      "recordAgain": "دوباره بگویید",
      "heard": "شنیدم",
      "openForm": "باز کردن فرم ثبت نوبت",
      "pickSlot": "یکی از این وقت‌ها را انتخاب کنید؛ فرم ثبت نوبت با همان پر می‌شود.",
      "hourTaken": "ساعت {{time}} پر است؛ نزدیک‌ترین وقت‌های خالی:",
      "hourFree": "ساعت {{time}} خالی است.",
      "slot": "{{day}}، ساعت {{time}}",
      "requestOnly": "این کلینیک ثبت مستقیم را بسته است؛ نوبت به‌صورت درخواست برای تأیید پذیرش فرستاده می‌شود.",
      "noSlotLine": "در این بازه برای {{name}} وقت خالی پیدا نشد. می‌توانید فرم را باز کنید و روز دیگری را انتخاب کنید.",
      "choosePatientLine": "چند بیمار با نامی نزدیک به «{{name}}» دارید. کدام است؟",
      "newPatient": "بیمار جدید است",
      "file": "پرونده {{file}}",
      "age": "{{age}} ساله",
      "phoneTail": "موبایل …{{tail}}",
      "notFoundLine": "بیماری به نام «{{name}}» در بیماران کلینیک‌های شما پیدا نشد.",
      "closest": "نزدیک‌ترین نام‌ها:",
      "noClinicTitle": "شما هنوز کلینیکی ندارید",
      "noClinicLine": "برای ثبت نوبت باید عضو یک کلینیک باشید یا مطب خود را بسازید. منشی همچنان پرونده‌ها و برنامهٔ امروز را برایتان می‌آورد.",
      "readOnlyTitle": "اشتراک کلینیک‌های شما به پایان رسیده است",
      "readOnlyLine": "تا وقتی کلینیک اشتراک را تمدید نکند، در آن نمی‌توان نوبت ثبت کرد.",
      "goReception": "رفتن به پذیرش",
      "dayTitle": "امروز {{total}} نوبت دارید",
      "dayCounts": "{{completed}} انجام‌شده · {{arrived}} حاضر · {{scheduled}} در انتظار",
      "dayRequested": "{{count}} درخواست در انتظار تأیید کلینیک",
      "dayNext": "پیش رو:",
      "dayNone": "امروز نوبت دیگری پیش رو ندارید.",
      "noHour": "خارج از نوبت",
      "unknownPatient": "بیمار",
      "status": {
        "scheduled": "در انتظار",
        "requested": "در انتظار تأیید کلینیک",
        "arrived": "حاضر",
        "in_visit": "در حال ویزیت"
      },
      "outOfScopeTitle": "این کار از منشی ساخته نیست",
      "topic": {
        "clinical_record": "نسخه، تشخیص و شرح حال را در خود ویزیت بنویسید.",
        "visit_flow": "شروع و پایان ویزیت از صفحهٔ پذیرش و خود ویزیت انجام می‌شود.",
        "mark_arrived": "ثبت حضور بیمار کار پذیرش کلینیک است.",
        "reschedule_or_cancel": "برای جابه‌جایی یا لغو نوبت، آن را در پذیرش باز کنید.",
        "money": "امور مالی را در «حسابداری» ببینید.",
        "send_message": "پیام به بیمار را از «پیام‌ها» بفرستید.",
        "delete_record": "منشی هیچ چیزی را حذف نمی‌کند.",
        "other": "منشی فقط نوبت، پیگیری، باز کردن پرونده و برنامهٔ امروز را آماده می‌کند."
      },
      "unavailableLine": "برنامهٔ امروز الان خوانده نشد. کمی بعد دوباره بپرسید.",
      "unknownLine": "منشی می‌تواند نوبت و پیگیری آماده کند، پرونده باز کند و برنامهٔ امروز را بگوید.",
      "failedLine": "دوباره بگویید. اگر تکرار شد، کار را از صفحهٔ مربوط انجام دهید.",
      "noCreditLine": "برای استفاده از منشی، {{coin}} خود را شارژ کنید.",
      "topUp": "شارژ {{coin}}",
      "charged": "برای این فرمان {{coin}} کسر شد.",
      "notCharged": "برای این فرمان {{coin}} کسر نشد."
    },
    "form": {
      "notice": "این فرم را منشی هوشمند از گفتهٔ شما پر کرده است؛ پیش از ثبت بررسی کنید.",
      "reception_clinic": "کلینیک: همانی که در پذیرش انتخاب شده است.",
      "working_hours": "کلینیک بر اساس ساعات حضور شما انتخاب شد.",
      "earliest_free": "کلینیکی انتخاب شد که اولین وقت خالی را دارد.",
      "newPatient": "بیمار جدید است؛ با ثبت نوبت پرونده‌اش ساخته می‌شود.",
      "heardPhone": "شماره‌ای که شنیدم: {{phone}}",
      "booked": "نوبت ثبت شد.",
      "requested": "درخواست نوبت برای تأیید کلینیک فرستاده شد."
    }
  }
}
